/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow_dropdown': {
    width: 14,
    height: 9,
    viewBox: '0 0 14 9',
    data: '<path pid="0" d="M7 9L.072 0h13.856z" _fill="#005BA5" fill-rule="evenodd"/>'
  }
})
